import React from "react";

const Lockers = ({ color = "white" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_245_2674)">
        <path
          d="M6.56191 4.84375V2.34375C6.56191 2.08487 6.35203 1.875 6.09316 1.875H2.34375C2.08487 1.875 1.875 2.08487 1.875 2.34375V4.84375C1.875 5.10262 2.08487 5.3125 2.34375 5.3125H6.09316C6.35206 5.3125 6.56191 5.10262 6.56191 4.84375ZM5.62441 4.375H2.8125V2.8125H5.62441V4.375Z"
          fill={color}
        />
        <path
          d="M13.6566 1.875H9.90723C9.64835 1.875 9.43848 2.08487 9.43848 2.34375V4.84375C9.43848 5.10262 9.64835 5.3125 9.90723 5.3125H13.6566C13.9155 5.3125 14.1254 5.10262 14.1254 4.84375V2.34375C14.1254 2.08487 13.9155 1.875 13.6566 1.875ZM13.1879 4.375H10.376V2.8125H13.1879V4.375Z"
          fill={color}
        />
        <path
          d="M15.5312 0H0.46875C0.209875 0 0 0.209875 0 0.46875V15.5312C0 15.7901 0.209875 16 0.46875 16H15.5312C15.7901 16 16 15.7901 16 15.5312V0.46875C16 0.209875 15.7901 0 15.5312 0ZM0.9375 0.9375H7.53125V15.0625H0.9375V0.9375ZM15.0625 15.0625H8.46875V0.9375H15.0625V15.0625Z"
          fill={color}
        />
        <path
          d="M5.46854 11.3125H3.00098C2.7421 11.3125 2.53223 11.5224 2.53223 11.7812C2.53223 12.0401 2.7421 12.25 3.00098 12.25H5.46857C5.72745 12.25 5.93732 12.0401 5.93732 11.7812C5.93732 11.5224 5.72745 11.3125 5.46854 11.3125Z"
          fill={color}
        />
        <path
          d="M12.9998 11.3125H10.5322C10.2734 11.3125 10.0635 11.5224 10.0635 11.7812C10.0635 12.0401 10.2734 12.25 10.5322 12.25H12.9998C13.2587 12.25 13.4686 12.0401 13.4686 11.7812C13.4686 11.5224 13.2587 11.3125 12.9998 11.3125Z"
          fill={color}
        />
        <path
          d="M5.46854 13.1875H3.00098C2.7421 13.1875 2.53223 13.3974 2.53223 13.6562C2.53223 13.9151 2.7421 14.125 3.00098 14.125H5.46857C5.72745 14.125 5.93732 13.9151 5.93732 13.6562C5.93732 13.3974 5.72745 13.1875 5.46854 13.1875Z"
          fill={color}
        />
        <path
          d="M12.9998 13.1875H10.5322C10.2734 13.1875 10.0635 13.3974 10.0635 13.6562C10.0635 13.9151 10.2734 14.125 10.5322 14.125H12.9998C13.2587 14.125 13.4686 13.9151 13.4686 13.6562C13.4686 13.3974 13.2587 13.1875 12.9998 13.1875Z"
          fill={{ color }}
        />
        <path
          d="M6.11719 6.80518C5.85831 6.80518 5.64844 7.01505 5.64844 7.27393V8.72646C5.64844 8.98533 5.85831 9.19521 6.11719 9.19521C6.37606 9.19521 6.58594 8.98533 6.58594 8.72646V7.27393C6.58594 7.01505 6.37606 6.80518 6.11719 6.80518Z"
          fill={{ color }}
        />
        <path
          d="M13.6562 6.80518C13.3974 6.80518 13.1875 7.01505 13.1875 7.27393V8.72646C13.1875 8.98533 13.3974 9.19521 13.6562 9.19521C13.9151 9.19521 14.125 8.98533 14.125 8.72646V7.27393C14.125 7.01505 13.9151 6.80518 13.6562 6.80518Z"
          fill={{ color }}
        />
      </g>
      <defs>
        <clipPath id="clip0_245_2674">
          <rect width="16" height="16" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Lockers;
